import { Box } from "@mui/material";

export const SectionCard: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    sx={{
      // Mantenemos la estructura plana original
      p: 3,
      borderRadius: 1.5, // Radio de esquina para un look moderno
      border: "1.5px solid", // Borde definido pero sutil
      borderColor: "divider", // Color divider padrão de MUI

      // CAMBIO CLAVE: Sombra externa potente y suave para que resalte
      //  boxShadow: "0 15px 50px rgba(0, 0, 0, 0.15), 0 8px 20px rgba(0, 0, 0, 0.1)",
      
      // Fondo que interactúa con la sombra
      bgcolor: "#fff", // Blanco estándar de MUI

      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", // Transición suave

          
        
        }}
      >
    {children}
  </Box>
);